import { formatCurrency } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Account } from '@core/models/account.model';
import {ApiService} from '@core/services/api/api.service';
import { AccountService } from '@core/state/account';
import { PeopleService } from '@core/state/people/people.service';
import { MortgageService } from '@core/state/mortgage/mortgage.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-saving-widget',
  templateUrl: './saving-widget.component.html',
  styleUrls: ['./saving-widget.component.scss'],
})
export class SavingWidgetComponent implements OnInit {
  private subs = new Subscription();

  hasSavings = false;
  index = 0;
  mortgageSelectIndex = 0;
  page  = 0;
  maxPage = 6;
  alternativeMortgageAddress = "";
  person = {
    first_name: "",
    middle_name: "",
    last_name: "",
    gender: "",
    date_of_birth: "",
    phone_number: "",
    mobile_number: "",
    marital_status: {
      name: ""
    },
    bsn: "",
    nationality: {
      name: ""
    }
  };
  personInfo = {
    person_id: 0,
    question: "",
    Response: 0
  };
  personGender = "";
  mortgageData = {
    data: {}
  };
  alternativeMortgageData = {
    data : {}
  };
  hasAlternativeMortgageData = false;
  titlePage = 0;
  title = {
    0: "Kun je besparen?",
    1: "Verbeteringen",
    2: "Wizard Besparen",
  }

  constructor(
    public api: ApiService,
    public account: AccountService,
    public mortgage: MortgageService,
    private peopleService: PeopleService
  ) { }

  ngOnInit() {
    this.subs.add(
      this.account.get().subscribe(data => {
        this.person = data;
        console.log(this.person);
        this.personInfo.person_id = data.id
        if (this.person.gender == "MALE") {
          this.personGender = "Man";
        }
        else if (this.person.gender == "FEMALE") {
          this.personGender = "Vrouw;"
        }
      })
    );

    this.subs.add(
      this.mortgage.get().subscribe(data => {
        Object.assign(this.mortgageData, data);
        console.log(this.mortgageData.data);
      })
    );
  }

  ionviewDidEnter() {
    for (let i = 0; i < this.mortgageData.data; i++) {
      console.log(`data number: ${i}`);
    } 
  }

  nextpage(step, index=0) {  
    if (step == 5) {
      this.personInfo.question = `Hypotheek besparing aanvraag \n Naam: ${this.alternativeMortgageData.data[index].name} \n Maandelijks kosten: ${this.alternativeMortgageData.data[index].cost}`
      this.peopleService.submitContactRequest(this.personInfo).subscribe(
        (data) => {
          console.log(data);
        }
      );
    }
    if (step == 1 && !this.hasAlternativeMortgageData) {
      this.hasAlternativeMortgageData = true;
      this.subs.add(
        this.api.get(`mortgages/${this.mortgageData.data[index].id}/alternatives`).subscribe(data => {
          Object.assign(this.alternativeMortgageData, data);
          console.log(this.alternativeMortgageData.data);
          this.mortgageSelectIndex = index
          
        })
      );
    }
    if (this.page == this.maxPage && step == 0) {
      this.page = 0;
      this.titlePage = this.page;
    } 
    else if (this.page < this.maxPage) {
      
      this.page = step + 1;
      if (this.titlePage < 2) {
        this.titlePage = this.page;
      }

    }
    console.log(`step: ${step} | Page: ${this.page}`);
  }

  alternativenextpage(step, index) {   
    if (step == 0 && !this.hasAlternativeMortgageData) {
      this.hasAlternativeMortgageData = true;
      this.subs.add(
        this.api.get(`mortgages/${this.mortgageData.data[index].id}/alternatives`).subscribe(data => {
          Object.assign(this.alternativeMortgageData, data);
          console.log(this.alternativeMortgageData.data);
          
        })
      );
    }
    if (this.page == this.maxPage && step == 0) {
      this.page = 0;
      this.titlePage = this.page;
    } 
    else if (this.page < this.maxPage) {
      this.index = index;
      this.page = step + 1;
      if (this.titlePage < 2) {
        this.titlePage = this.page;
      }

    }
    console.log(`step: ${step} | Page: ${this.page}`);
  }

  nhgCheck(value) {
    if (value == false) {
      let output = "Nee";
      return output
    }
    else if (value == true) {
      let output = "Ja";
      return output
    }
  }

  backpage(step) {   
    if (this.page == this.maxPage && step == 0) {
      this.page = 0;
      this.titlePage = this.page;
    } 
    else if (this.page < this.maxPage) {
      
      this.page = step - 1;
      if (this.titlePage < 2) {
        this.titlePage = this.page;
      }

    }
    console.log(`step: ${step} | Page: ${this.page}`);
  }

  numberToCurrency(value) {
    let output = value.toLocaleString('nl-NL',
    {style: 'currency', currency: 'EUR'}
  );
  return output;
  }

  stringToCurrency(value) {
    value = parseInt(value);
    let output = value.toLocaleString('nl-NL',
    {style: 'currency', currency: 'EUR'}
  );
  return output;
  }

  dateRemoveTime(value) {
    let createdDate = value;
    createdDate = new Date(createdDate);
    let output = createdDate.toLocaleDateString();
    return output;
  }

}
